module.exports = __webpack_public_path__ + "static/media/google_de.235818b9.png";